import React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import { Columns } from "@bw/modules"
import styled from "styled-components"

const WrapperImagesLinks = styled(Link)`
  position: relative;
  width: 100%;
  height: auto;
  text-align: center;
  text-decoration: none;

  > h4 {
    font-family: "OneDirection";
    font-size: 35px;
    color: var(--dark);
    width: fit-content;
    position: relative;
    &:after {
      content: "";
      display: block;
      position: absolute;
      width: 100%;
      height: 7px;
      background-color: var(--primary);
      transition: background 0.2s ease-in-out;
    }
    &:hover {
      &:after {
        background-color: var(--secondary);
      }
    }
  }
`

const ImagesLinks = ({ ImageLinks }) => {
  if (!ImageLinks || ImageLinks.length === 0) {
    return null
  }

  return (
    <Columns>
      {ImageLinks.map((ImageLink, i) => {
        return (
          <WrapperImagesLinks key={i} to={ImageLink.entry}>
            <h4>{ImageLink.title}</h4>
            {ImageLink.image}
          </WrapperImagesLinks>
        )
      })}
    </Columns>
  )
}

ImagesLinks.propTypes = {
  ImageLinks: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      entry: PropTypes.string.isRequired,
      image: PropTypes.element.isRequired,
    })
  ),
}

export { ImagesLinks }
